import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import type { Locale } from '@change-corgi/config/locales';

import { L10nContextProvider } from './context';

type Props = {
	countryCode: string;
	locale: Locale;
};

export const L10nProvider: React.FC<PropsWithChildren<Props>> = ({ children, countryCode, locale }) => {
	const value = useMemo(
		() => ({
			countryCode,
			locale,
		}),
		[countryCode, locale],
	);

	return <L10nContextProvider value={value}>{children}</L10nContextProvider>;
};
